import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EditorComponent } from '@tinymce/tinymce-angular';

@Component({
    standalone: false,
    selector: 'tiny-mce-comment-attribute',
    templateUrl: './tiny-mce-comment.component.html',
    styleUrls: ['./tiny-mce-comment.component.scss']
})
export class TinyMceCommentComponent implements OnInit {
    constructor() { }

    @Input()
    model: any;

    @Input()
    fieldName: any;

    @ViewChild(EditorComponent)
    editor: EditorComponent;

    ngOnInit() { }

    setupEditor(editor) {
        editor.settings.readonly = true;
    }
}
